import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


export function requireOneOf(controlNames: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && control.value.toString().trim()) {
      return null;
    }
    
    const formGroup = control.parent;
    if (!formGroup) return null;
    
    const anySiblingHasValue = controlNames.some(name => {
      const siblingControl = formGroup.get(name);
      if (!siblingControl) return false;
      
      const value = siblingControl.value?.toString().trim() || '';
      return value !== '';
    });
    
    return anySiblingHasValue ? null : { required: true };
  };
}
